import React from "react";
import YouTube from "react-youtube";

export default function Video() {
    const opts = {
        playerVars: {
            rel: 0,
            modestbranding: 1,
        },
    };
    return (
        <div className="video-wrapper">
            <div className="video-inner">
                <YouTube videoId="73gJRFb9PWg" opts={opts} />
            </div>
        </div >
    );
}
